/* Collection below-grid FAQ accordion.
   Each question is a button controlling a region. Answers stay in the HTML for
   crawlers and for JSON-LD; the script only toggles the hidden state. */
(function () {
  function toggle(button) {
    var answer = document.getElementById(button.getAttribute('aria-controls'));
    if (!answer) return;
    var expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    answer.hidden = expanded;
  }

  function init() {
    var buttons = document.querySelectorAll('.cbg-faq-button');
    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function () { toggle(button); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
